import {
  backgroundColorAlt as leftColumnGrey,
  spacing16,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const headerHeight = 42;
const footerHeight = 60;
const headerFooterHeight = headerHeight + footerHeight;
const fillDivShift = headerFooterHeight + 2; //?I don't know why this is needed :(
const FullHeight = styled.div`
  min-height: calc(100vh - ${headerFooterHeight}px);
  display: flex;
  align-items: stretch;
  flex-direction: column;
`;

const makeFixedStylesString = `z-index:2000; height:100%; position:absolute; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);`;
const LeftColumn = styled.div`
  background-color: ${leftColumnGrey};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - ${headerFooterHeight}px);
  ${(props) => (props.makeFixed ? makeFixedStylesString : null)}
  min-width:390px;
  width: 390px !important;
  //${(props) => props.hidden ? "display:none" : ""};
`;
const RightColumn = styled.div`
  width: 100%;
`;
const UserOptionsHolder = styled.div`
  padding: ${spacing16};
  min-width: 275px;
`;
const RelativeDiv = styled.div`
  position: relative;
`;
const ChildrenHolder = styled.div`
  margin-bottom: ${spacing16};
`;

const FillSplit = styled.div`
  display: ${(props) => (props.menuOpen ? "flex" : "block")};
  min-height: calc(100vh - ${fillDivShift}px);
`;
const LightFillContainer = styled.div`
  min-height: calc(100vh - ${fillDivShift}px);
`;
export {
  FullHeight,
  LeftColumn,
  RightColumn,
  UserOptionsHolder,
  RelativeDiv,
  ChildrenHolder,
  FillSplit,
  LightFillContainer,
  leftColumnGrey
};
